import { render, staticRenderFns } from "./WaitingAnimation.vue?vue&type=template&id=b2f04c80&scoped=true&"
import script from "./WaitingAnimation.vue?vue&type=script&lang=js&"
export * from "./WaitingAnimation.vue?vue&type=script&lang=js&"
import style0 from "./WaitingAnimation.vue?vue&type=style&index=0&id=b2f04c80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f04c80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardText,VDialog,VProgressCircular})
